import { PageHero } from "../components/Layout";
import { Reveal } from "../components/Reveal";
import { CollabCTA } from "../components/CollabCTA";
import { useSite } from "../context/SiteContext";
import { mediaUrl } from "../lib/api";
import { useSeo } from "../lib/useSeo";

const Block = ({ label, text, testid }) =>
  text ? (
    <div className="border-t border-line pt-6" data-testid={testid}>
      <p className="eyebrow text-wine">{label}</p>
      <p className="mt-4 whitespace-pre-line text-base leading-relaxed text-charcoal/85">{text}</p>
    </div>
  ) : null;

export default function About() {
  useSeo("About — The Intention Behind BWI", "BWI is an independent, creator-led beauty brand content studio making thoughtful image and video advertising for makeup, skincare and jewellery brands.");
  const { settings } = useSite();
  const f = settings?.founder || {};
  return (
    <>
      <PageHero eyebrow="About" testid="about-title" title={<>The Intention <span className="italic">Behind BWI.</span></>} />
      <section className="mx-auto max-w-[1400px] px-6 pb-28 md:px-10 md:pb-40">
        <div className="grid gap-14 md:grid-cols-12 md:gap-10">
          <Reveal className="md:col-span-6">
            <div className="frame relative aspect-[4/5] overflow-hidden bg-sand">
              {f.photo && <img src={mediaUrl(f.photo)} alt={f.name ? `Portrait of ${f.name}` : "Founder portrait"} className="h-full w-full object-cover" data-testid="founder-photo" />}
            </div>
          </Reveal>
          <Reveal className="space-y-6 text-lg leading-relaxed text-charcoal/90 md:col-span-5 md:col-start-8 md:self-center md:text-xl" delay={0.12}>
            <p className="font-serif text-3xl font-light leading-snug text-wine md:text-4xl">
              Built With Intention began with a simple belief: <span className="italic">beautiful visuals should have a purpose.</span>
            </p>
            <p className="text-base md:text-lg">BWI brings together a love for beauty, jewellery and visual storytelling to create thoughtful advertising content.</p>
            <p className="text-base md:text-lg">Every concept, image and film is approached with creativity, care and attention to detail.</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-sand" data-testid="founder-section">
        <div className="mx-auto grid max-w-[1400px] gap-14 px-6 py-28 md:grid-cols-12 md:px-10 md:py-40">
          <Reveal className="md:col-span-5">
            <p className="eyebrow text-wine">Meet the Creative Mind</p>
            <h2 className="mt-5 font-serif text-5xl font-light text-wine md:text-6xl" data-testid="founder-name">{f.name}</h2>
            {f.title && <p className="mt-4 text-sm uppercase tracking-[0.2em] text-muted-ink">{f.title}</p>}
          </Reveal>
          <Reveal className="space-y-10 md:col-span-6 md:col-start-7" delay={0.12}>
            <Block label="Biography" text={f.bio} testid="founder-bio" />
            <Block label="Creative Journey" text={f.journey} testid="founder-journey" />
            <Block label="Personal Inspiration" text={f.inspiration} testid="founder-inspiration" />
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 py-28 text-center md:px-10 md:py-44" data-testid="philosophy-section">
        <Reveal>
          <p className="eyebrow text-wine">Our Philosophy</p>
          <blockquote className="mx-auto mt-8 max-w-4xl font-serif text-4xl font-light leading-tight text-wine md:text-7xl">
            “Not just created. <span className="italic">Created with intention.</span>”
          </blockquote>
        </Reveal>
      </section>
      <CollabCTA />
    </>
  );
}
